
import { useDispatch } from 'react-redux';
import { deleteStoryboard } from 'actions/storyboard';

import _ from 'lodash';
import cx from 'classnames'
import { Offcanvas, Button } from "react-bootstrap";

import styles from './delete.module.scss';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { invalidateStoryboardState } from 'actions/storyboard';

export const DeleteStoryboard = ({ storyboard, onClose }) => {
  const dispatch = useDispatch();

  const deleting = useSelector(state => _.get(state, 'storyboards.storyboard.deleting'));
  const deleted = useSelector(state => _.get(state, 'storyboards.storyboard.deleted'));

  useEffect(() => {
    if(storyboard && deleted){
      onClose();
      dispatch(invalidateStoryboardState());
    }
  }, [deleted]);

  const handleDelete = () => {
    dispatch(deleteStoryboard(storyboard.id));
  }

  if(!storyboard){
    return false;
  }

  return (
    <Offcanvas className={cx(styles.deleteStoryboard)} show={storyboard != null} placement="end">
      <i onClick={onClose} className={cx(styles.close, "cleverstory-close")} />
      <header className={styles.header}>
        <h1>Deleting {storyboard.name}</h1>
        <p>Sure you want to delete this Storyboard?</p>
        <footer className={styles.actions}>
          <Button variant='primary' 
            type="submit" 
            disabled={deleting}
            onClick={handleDelete}
          >
            {deleting ? 'Deleting' : 'Delete'}
          </Button>
          <Button variant='secondary' 
            type="reset" 
            disabled={deleting}
            onClick={onClose}
          >
            Cancel
          </Button>
        </footer>
      </header>
    </Offcanvas>
  );
}